import React, { useEffect, useState } from 'react';
import { LockClosedIcon } from '@heroicons/react/24/solid';
import { motion } from 'framer-motion';

const Achievements = () => {
  const [achievements, setAchievements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAchievements = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = localStorage.getItem('access_token');
        const response = await fetch('/api/achievements/user', {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        });
        if (!response.ok) {
          throw new Error('Ошибка при загрузке достижений');
        }
        const data = await response.json();
        setAchievements(data);
      } catch (err) {
        setError(err.message || 'Не удалось загрузить достижения');
      } finally {
        setLoading(false);
      }
    };
    fetchAchievements();
  }, []);

  if (loading) {
    return <div className="text-center text-gray-500 mt-8">Загрузка достижений...</div>;
  }

  if (error) {
    return <div className="text-center text-red-500 mt-8">{error}</div>;
  }

  return (
    <div className="min-h-screen bg-blue-50 dark:bg-gray-900 py-2 sm:py-6 px-0.5 sm:px-1 md:px-0 transition-colors overflow-x-hidden">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-2xl sm:text-3xl font-bold mb-2 sm:mb-6 text-center text-gray-900 dark:text-gray-100">Достижения</h1>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 sm:gap-3">
          {achievements.map((ach) => (
            <motion.div
              key={ach.id}
              whileTap={{ scale: 0.98 }}
              className={`relative flex flex-col items-center p-3 rounded-xl border transition-all
                ${ach.unlocked 
                  ? 'border-yellow-300 bg-yellow-50 dark:bg-yellow-900/30 dark:border-yellow-500' 
                  : 'border-gray-200 bg-white dark:bg-gray-800 dark:border-gray-700 opacity-60'}
              `}
            >
              {/* Иконка */}
              <div className="w-12 h-12 mb-2 flex items-center justify-center">
                {ach.unlocked && ach.icon_url ? (
                  <img 
                    src={ach.icon_url} 
                    alt="" 
                    className="w-10 h-10 object-contain" 
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'block';
                    }}
                  />
                ) : null}
                <LockClosedIcon 
                  className={`w-8 h-8 ${ach.unlocked && ach.icon_url ? 'hidden' : 'block'} text-gray-300 dark:text-gray-600`} 
                />
              </div>
              
              {/* Название */}
              <h2 className={`text-sm font-bold text-center mb-1 ${ach.unlocked ? 'text-yellow-700 dark:text-yellow-300' : 'text-gray-500 dark:text-gray-400'}`}>
                {ach.name}
              </h2>
              
              {/* Баллы */}
              <div className={`text-xs mb-1 ${ach.unlocked ? 'text-yellow-600 dark:text-yellow-200' : 'text-gray-400'}`}>
                +{ach.points || 0} баллов
              </div>
              
              {/* Описание */}
              <p className="text-xs text-gray-500 dark:text-gray-400 text-center mb-2 line-clamp-2">
                {ach.description}
              </p>
              
              {/* Прогресс бар */}
              <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2 mb-1">
                <div
                  className={`h-2 rounded-full transition-all ${ach.unlocked ? 'bg-yellow-400' : 'bg-blue-400'}`}
                  style={{ width: `${ach.progress || 0}%` }}
                />
              </div>
              
              {/* Статус */}
              <div className="text-xs text-gray-400">
                {ach.unlocked ? (
                  <span className="text-green-600 dark:text-green-400">✓ Получено</span>
                ) : (
                  <span>{ach.progress || 0}%</span>
                )}
              </div>
            </motion.div>
          ))}
        </div>
        {achievements.length === 0 && (
          <div className="text-center text-gray-500 dark:text-gray-400 mt-8">
            У вас пока нет достижений. Продолжайте тренироваться!
          </div>
        )}
      </div>
    </div>
  );
};

export default Achievements;
